import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import DashboardLayout from "../../ProjectDashboard/DashboardLayout";

const PrivateRoute = () => {
  let isLoggedIn = useSelector((store) => store.appState.isLoggedIn || false);
  return isLoggedIn ? (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  ) : (
    <Navigate to="/Login" />
  );
};

export default PrivateRoute;
